import { useToast } from 'src/hooks/use-toast';
import {
  Toast,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from 'src/components/ui/toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({
        id,
        title,
        description,
        message,
        action,
        variant,
        ...props
      }) {
        // Combine message, description, and title into a single message
        const displayMessage = message || description || title || '';

        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-center gap-3">
              {displayMessage && <ToastTitle>{displayMessage}</ToastTitle>}
            </div>
            {action}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
